import { IconProps } from '.';

const QuoteIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      {...rest}
    >
      <path
        d="M24.083 31.6667L19.9997 37.5L15.9163 31.6667H4.99967C4.07921 31.6667 3.33301 30.9205 3.33301 30V6.66667C3.33301 5.7462 4.07921 5 4.99967 5H34.9997C35.9202 5 36.6663 5.7462 36.6663 6.66667V30C36.6663 30.9205 35.9202 31.6667 34.9997 31.6667H24.083Z"
        fill={color}
      />

      <g transform="translate(11, 10)">
        <path
          d="M6.60048 1.30943L5.74948 0C2.34199 1.47375 0 4.45569 0 7.78205C0 9.6732 0.527375 10.8399 1.50961 11.8793C2.12792 12.5339 3.10622 13 4.12926 13C5.97219 13 7.46615 11.5105 7.46615 9.6732C7.46615 7.9233 6.11024 6.5154 4.39007 6.35647C4.08253 6.32796 3.77211 6.33328 3.47637 6.37396C3.47637 5.7797 3.42078 3.02473 6.60048 1.30943Z"
          fill="white"
        />
        <path
          d="M16.1343 1.30943L15.2833 0C11.8759 1.47375 9.53385 4.45569 9.53385 7.78205C9.53385 9.6732 10.0613 10.8399 11.0434 11.8793C11.6618 12.5339 12.6402 13 13.6632 13C15.506 13 17 11.5105 17 9.6732C17 7.9233 15.6441 6.5154 13.924 6.35647C13.6164 6.32796 13.306 6.33328 13.0103 6.37396C13.0103 5.7797 12.9546 3.02473 16.1343 1.30943Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default QuoteIcon;
